export type PlayerBoard = 'achievements' | 'activity';
export type PlayerScope = 'all' | 'friends';
/** Internal rollout only. Early-access membership (betaUser) does not grant access. */
export function canViewPlayerRankings(
  user?: { role?: unknown; internalUser?: unknown; beta_user?: unknown; status?: unknown } | null,
) {
  return (
    !!user &&
    (user.status === undefined || user.status === 'active') &&
    (user.role === 'admin' || user.role === 'superadmin' || !!user.internalUser || !!user.beta_user)
  );
}
export type PlayerHonor = { key: string; name: string; icon: number };
export type RankedPlayer = {
  id: string;
  nickname: string;
  avatarUrl: string;
  rank: number | null;
  points: number;
  unlocked: number;
  activeDays: number;
  games: number;
  days: boolean[];
  badges: PlayerHonor[];
  title: string;
};
export type PlayerRankings = {
  board: PlayerBoard;
  scope: PlayerScope;
  items: RankedPlayer[];
  total: number;
  me: RankedPlayer | null;
  week: { start: string; end: string; today: number };
};
